import React from 'react'
import { Card, QuestionText } from './styles';
export const EmptyStateCard = ({text,onClick}) =>{

    return(
<Card onClick={()=> onClick(text)}> 
    <QuestionText >{text}</QuestionText>
</Card>
    );
}